import authService from './authService';
import type {
  AnnualBillingFilters,
  BillingHistoryFilters,
  BillingHistoryResponse,
  DasReportResponse,
} from '../types/billingHistory';

// ─── Service ────────────────────────────────────────────────────

class BillingHistoryService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  async getBillingHistory(filters: BillingHistoryFilters): Promise<BillingHistoryResponse> {
    const params = new URLSearchParams({
      month: filters.month.toString(),
      year: filters.year.toString(),
    });

    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/reports/billing-history?${params}`);
    if (!response.ok) throw new Error('Erro ao carregar histórico de faturamento');

    return response.json();
  }

  async getAnnualBilling(filters: AnnualBillingFilters): Promise<BillingHistoryResponse> {
    const params = new URLSearchParams({
      year: filters.year.toString(),
    });

    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/reports/annual-billing?${params}`);
    if (!response.ok) throw new Error('Erro ao carregar faturamento do ano');

    return response.json();
  }

  async getDasCalculation(filters: BillingHistoryFilters): Promise<DasReportResponse> {
    const params = new URLSearchParams({
      month: filters.month.toString(),
      year: filters.year.toString(),
    });

    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/reports/das-calculation?${params}`);
    if (!response.ok) throw new Error('Erro ao carregar cálculo do DAS');

    return response.json();
  }
}

export const billingHistoryService = new BillingHistoryService();
export default billingHistoryService;
